module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [(!_vm.loading) ? _c(_vm.card ? "b-card" : "div", {
    tag: "component",
    staticClass: "full-info"
  }, [
    [_vm._t("above"), (_vm.showFields.length) ? [_vm._l((_vm.showFields[0]), function(row) {
      return _c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "name",
        class: _vm.nameFieldClasses
      }, [_vm._v(_vm._s(row.name))]), _c('div', {
        staticClass: "value",
        class: _vm.valueFieldClasses
      }, [_vm._v(_vm._s(row.value))])])
    }), (_vm.showFields.length > 1) ? [_c('b-collapse', {
      staticClass: "collapse-show",
      attrs: {
        "id": "collapse"
      }
    }, _vm._l((_vm.showFields.slice(1)), function(block, key) {
      return _c('div', {
        staticClass: "mt-4 mt-lg-0"
      }, _vm._l((block), function(row) {
        return _c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "name",
          class: _vm.nameFieldClasses
        }, [_vm._v(_vm._s(row.name))]), _c('div', {
          staticClass: "value",
          class: _vm.valueFieldClasses
        }, [_vm._v(_vm._s(row.value))])])
      }))
    }))] : _vm._e(), (_vm.showMore) ? _c('div', {
      staticClass: "text-center mt-4 hidden-md-up"
    }, [_c('b-btn', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle.collapse",
        modifiers: {
          "collapse": true
        }
      }],
      class: {
        active: _vm.active
      },
      attrs: {
        "variant": "link"
      },
      on: {
        "click": function($event) {
          _vm.active = !_vm.active
        }
      }
    }, [_vm._v(_vm._s(_vm.active ? _vm.$t('terms.misc.show-less') : _vm.$t('terms.misc.show-more')))])], 1) : _vm._e()] : _vm._e(), _vm._t("below")]
  ], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d9d0d6a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/full-info-box/FullInfoBox.vue
// module id = 920
// module chunks = 1